import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-account-roles-card',
  templateUrl: './account-roles-card.component.html',
  styleUrls: ['./account-roles-card.component.scss']
})
export class AccountRolesCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('roles-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('roles-counts-spinner');
      this.showCounter = true;
      this.count = this.data.length;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
      this.spinnerService.hide('roles-counts-spinner');
    }
  }
}
